import { Helmet } from 'react-helmet-async';
import EditCandidateView from 'src/sections/candidates/view/edit-candidate-view';
// ----------------------------------------------------------------------

export default function EditCandidate() {
  return (
    <>
      <Helmet>
        <title>Hireintel - Dashboard - Edit Candidate</title>
      </Helmet>

      <EditCandidateView/>
    </>
  );
}
